export const CLIENT_PRONOUNS = Object.freeze({
  'He/Him': 'he/him/his',
  'She/Her': 'she/her/hers',
  'They/Them': 'they/them/theirs'
})
